import { Layout, Link, Page, Text } from "@shopify/polaris"
import type { HomeStateSync, SyncPayload } from "../../typings/types"
import { Trans, useTranslation } from "react-i18next"
import { createCountdown, objToParams } from "../helpers/misc"
import { useEffect, useRef, useState } from "react"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"

import Confetti from "react-confetti"

const ConfirmSync = () => {
  const location = useLocation()
  const [queryParams] = useSearchParams()
  const navigate = useNavigate()
  const { t } = useTranslation("confirm")
  const width = window.innerWidth
  const height = window.innerHeight
  const [countdownSeconds, setCountdownSeconds] = useState<number>(6)
  const homeParams = useRef<HomeStateSync>()

  const redirectToHome = () => navigate("/", { state: homeParams.current })

  useEffect(() => {
    const charge_id = queryParams.get("charge_id")
    if (!charge_id) {
      navigate("/")
      return
    }
    const { state } = location
    if (state) {
      homeParams.current = state as HomeStateSync
    } else {
      const syncDomain = queryParams.get("sync_domain")
      if (!syncDomain) throw new Error("No sync domain")
      const forceUpdate = queryParams.get("forceUpdate")
      const confirmCount = queryParams.get("confirmCount")
      homeParams.current = {
        syncDomain,
        forceUpdate: forceUpdate === "true",
        selectedAt: queryParams.get("selectedAt") || undefined,
        confirmCount: confirmCount ? Number(confirmCount) : undefined,
        syncConfirmation: true,
      }
    }
    // redirect to homepage
    createCountdown(countdownSeconds, setCountdownSeconds, redirectToHome)
  }, [])

  return (
    <Page>
      <Layout>
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text variant="heading2xl" as="h1">
            {t("confirm:sync.happening")}
          </Text>
          <br />
          <Text variant="headingLg" as="p">
            {t("confirm:sync.beingSynced")}
          </Text>
          <br />
          <br />
          <br />
          <Text tone="subdued" as="p">
            <Trans
              i18nKey="confirm:redirect"
              countdownSeconds={countdownSeconds}
            >
              You'll be redirected to the main page within{" "}
              {{ countdownSeconds }} seconds. Or{" "}
              <Link onClick={redirectToHome}>click here</Link>
            </Trans>
          </Text>
          <Confetti
            numberOfPieces={500}
            recycle={false}
            gravity={0.05}
            friction={0.99}
            width={width}
            height={height}
          />
        </div>
      </Layout>
    </Page>
  )
}

export default ConfirmSync
